var escape = require("../../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1ef2cf9c] .el-progress--dashboard .el-progress__text{font-weight:700!important;font-size:16px!important}.data-mangment-bg[data-v-1ef2cf9c]{background-image:url(" + escape(require("../../../../assets/images/platform-monitoring-data.png")) + ")}", ""]);

// exports
